<template>
  <div class="forgot-password-container">
    <!-- 忘記密碼的標題 -->
    <h1 class="forgot-password-title">忘記密碼</h1>
    
    <!-- 電子郵件輸入區域 -->
    <div class="email-input-container">
      <label for="email">請輸入您的電子郵件地址</label>
      <input type="email" id="email" v-model="email" placeholder="example@example.com" />
    </div>

    <!-- 送出按鈕，加入禁用功能 -->
    <!-- <button 
      class="submit-button" 
      @click="handleSubmit" 
      :disabled="buttonDisabled">
      送出
    </button>
    <p v-if="countdown > 0" class="countdown-message">
      請在 {{ countdown }} 秒後，即可重送重製密碼信件...
    </p> -->

    <!-- 送出按鈕，加入禁用功能 -->
    <button 
      class="submit-button" 
      @click="handleSubmit" 
      :disabled="buttonDisabled">
      {{ buttonText }}
    </button>

    <!-- 圓形進度條 -->
    <div v-if="loading" class="progress-container">
      <div class="progress-circle"></div>
      <p>傳送中，請稍候...</p>
    </div>

    <!-- 成功提示訊息 -->
    <p v-if="successMessage" class="success-message">{{ successMessage }}</p>

    <!-- 錯誤訊息 -->
    <p v-if="errorMessage" class="error-message">{{ errorMessage }}</p>
  </div>
</template>

<script>
import ForgotPage from "@/assets/js/forgot.js";

export default {
  name: "ForgotPage",
  mixins: [ForgotPage], // 混入邏輯
};
</script>

<style src="@/assets/css/forgot.css" scoped></style>